// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Full-page gate ─────────────────────────────────────── */
.tier-gate--page {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 60vh;
    padding: 48px 24px;
    text-align: center;
    gap: 16px;
}

/* ── Inline gate ────────────────────────────────────────── */
.tier-gate--inline {
    position: relative;
    border-radius: 12px;
    overflow: hidden;
}

.tier-gate__blurred {
    filter: blur(4px);
    pointer-events: none;
    user-select: none;
    opacity: 0.4;
}

.tier-gate__overlay {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.55);
    backdrop-filter: blur(2px);
    gap: 10px;
    padding: 24px;
    text-align: center;
}

/* ── Lock icon ──────────────────────────────────────────── */
.tier-gate__icon {
    width: 52px;
    height: 52px;
    color: #c0a053;
    flex-shrink: 0;
}

.tier-gate--inline .tier-gate__icon {
    width: 32px;
    height: 32px;
}

/* ── Text ───────────────────────────────────────────────── */
.tier-gate__heading {
    font-size: 1.2rem;
    font-weight: 400;
    color: #f0f0f0;
    margin: 0;
    line-height: 1.4;
}

.tier-gate--inline .tier-gate__heading {
    font-size: 0.9375rem;
}

.tier-gate__tier-name {
    color: #c0a053;
    font-weight: 600;
}

.tier-gate__sub {
    font-size: 0.875rem;
    color: #909090;
    margin: 0;
    line-height: 1.5;
}

/* ── CTA button ─────────────────────────────────────────── */
.tier-gate__btn {
    display: inline-block;
    margin-top: 8px;
    padding: 11px 28px;
    border-radius: 10px;
    border: 1px solid rgba(192, 159, 83, 0.5);
    background: linear-gradient(180deg, rgba(192, 159, 83, 0.22) 0%, rgba(160, 130, 65, 0.14) 100%);
    color: #faf6ee;
    font-size: 0.9375rem;
    font-weight: 500;
    text-decoration: none;
    transition: border-color 0.2s ease, background 0.2s ease;
}

.tier-gate__btn:hover {
    border-color: rgba(192, 159, 83, 0.8);
    background: linear-gradient(180deg, rgba(192, 159, 83, 0.32) 0%, rgba(160, 130, 65, 0.22) 100%);
    color: #faf6ee;
    text-decoration: none;
}

.tier-gate__link {
    color: #c0a053;
    text-decoration: none;
}

.tier-gate__link:hover {
    text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/Components/TierGate/Style.css"],"names":[],"mappings":"AAAA,8DAA8D;AAC9D;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;AACb;;AAEA,8DAA8D;AAC9D;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,+BAA+B;IAC/B,0BAA0B;IAC1B,SAAS;IACT,aAAa;IACb,kBAAkB;AACtB;;AAEA,8DAA8D;AAC9D;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,8DAA8D;AAC9D;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,SAAS;IACT,gBAAgB;AACpB;;AAEA,8DAA8D;AAC9D;IACI,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,yCAAyC;IACzC,+FAA+F;IAC/F,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,qBAAqB;IACrB,wDAAwD;AAC5D;;AAEA;IACI,qCAAqC;IACrC,+FAA+F;IAC/F,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":["/* ── Full-page gate ─────────────────────────────────────── */\n.tier-gate--page {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 60vh;\n    padding: 48px 24px;\n    text-align: center;\n    gap: 16px;\n}\n\n/* ── Inline gate ────────────────────────────────────────── */\n.tier-gate--inline {\n    position: relative;\n    border-radius: 12px;\n    overflow: hidden;\n}\n\n.tier-gate__blurred {\n    filter: blur(4px);\n    pointer-events: none;\n    user-select: none;\n    opacity: 0.4;\n}\n\n.tier-gate__overlay {\n    position: absolute;\n    inset: 0;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    background: rgba(0, 0, 0, 0.55);\n    backdrop-filter: blur(2px);\n    gap: 10px;\n    padding: 24px;\n    text-align: center;\n}\n\n/* ── Lock icon ──────────────────────────────────────────── */\n.tier-gate__icon {\n    width: 52px;\n    height: 52px;\n    color: #c0a053;\n    flex-shrink: 0;\n}\n\n.tier-gate--inline .tier-gate__icon {\n    width: 32px;\n    height: 32px;\n}\n\n/* ── Text ───────────────────────────────────────────────── */\n.tier-gate__heading {\n    font-size: 1.2rem;\n    font-weight: 400;\n    color: #f0f0f0;\n    margin: 0;\n    line-height: 1.4;\n}\n\n.tier-gate--inline .tier-gate__heading {\n    font-size: 0.9375rem;\n}\n\n.tier-gate__tier-name {\n    color: #c0a053;\n    font-weight: 600;\n}\n\n.tier-gate__sub {\n    font-size: 0.875rem;\n    color: #909090;\n    margin: 0;\n    line-height: 1.5;\n}\n\n/* ── CTA button ─────────────────────────────────────────── */\n.tier-gate__btn {\n    display: inline-block;\n    margin-top: 8px;\n    padding: 11px 28px;\n    border-radius: 10px;\n    border: 1px solid rgba(192, 159, 83, 0.5);\n    background: linear-gradient(180deg, rgba(192, 159, 83, 0.22) 0%, rgba(160, 130, 65, 0.14) 100%);\n    color: #faf6ee;\n    font-size: 0.9375rem;\n    font-weight: 500;\n    text-decoration: none;\n    transition: border-color 0.2s ease, background 0.2s ease;\n}\n\n.tier-gate__btn:hover {\n    border-color: rgba(192, 159, 83, 0.8);\n    background: linear-gradient(180deg, rgba(192, 159, 83, 0.32) 0%, rgba(160, 130, 65, 0.22) 100%);\n    color: #faf6ee;\n    text-decoration: none;\n}\n\n.tier-gate__link {\n    color: #c0a053;\n    text-decoration: none;\n}\n\n.tier-gate__link:hover {\n    text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
